<div class="alert alert-primary" *ngIf="practitioner">
  <div *ngIf="practitioner.status === practitionerStatusEnum.PendingApproval">Your application is pending approval.</div>
  <div *ngIf="practitioner.status === practitionerStatusEnum.ApprovedConditionally">Your application has been approved with conditions. Please make the required changes.</div>
  <div *ngIf="practitioner.status === practitionerStatusEnum.Rejected">Your application has been rejected. Please contact hello@zayamed.com for more information.</div>
  <!-- <div *ngIf="practitioner.status === practitionerStatusEnum.UpdatesPendingApproval">
    Your profile updates have been submitted and are in review.
    <br>
    <ul>
      <li *ngFor="let item of pendingUpdatesList" [innerHtml]="item"></li>
    </ul>
  </div> -->
</div>
